import {Billing} from 'actions/actionTypes';

export const changeIsRecurringPayment = (isRecurringPayment) => ({ type: Billing.CHANGE_IS_RECURRING_PAYMENT, payload: isRecurringPayment });

export const changeIsInventory = () => ({ type: Billing.CHANGE_IS_INVENTORY});